module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-grid "
  }, [_c('div', {
    staticClass: "p-col-12 p-md-6 p-lg-4"
  }, [_c('div', {
    staticClass: "box bgPersonal"
  }, [_c('h4', {
    staticClass: "titleColor"
  }, [_vm._v("Personal Info")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "p-fluid "
  }, [_c('div', {
    staticClass: "p-field p-grid"
  }, [_c('label', {
    staticClass: "p-col-12 p-mb-2 p-md-2 p-mb-md-0",
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("EmpName")]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-10"
  }, [_c('span', [_vm._v("Sushant Shiwakoti(0003)")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-grid"
  }, [_c('label', {
    staticClass: "p-col-12 p-mb-2 p-md-2 p-mb-md-0",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-10"
  }, [_c('span', [_vm._v("9843263274")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-grid"
  }, [_c('label', {
    staticClass: "p-col-12 p-mb-2 p-md-2 p-mb-md-0",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-10"
  }, [_c('span', [_vm._v("sushntcc@gmail.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-grid"
  }, [_c('label', {
    staticClass: "p-col-12 p-mb-2 p-md-2 p-mb-md-0",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("BloodGroup")]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-10"
  }, [_c('span', [_vm._v("0+")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-6 p-lg-4"
  }, [_c('div', {
    staticClass: "box bgPersonal"
  }, [_c('h4', {
    staticClass: "titleColor"
  }, [_vm._v("Positions & Jobs")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "p-fluid "
  }, [_c('div', {
    staticClass: "p-field p-grid"
  }, [_c('label', {
    staticClass: "p-col-12 p-mb-2 p-md-2 p-mb-md-0",
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Designation")]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-10"
  }, [_c('span', [_vm._v("Software Engineer")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-grid"
  }, [_c('label', {
    staticClass: "p-col-12 p-mb-2 p-md-2 p-mb-md-0",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("JobTitle")]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-10"
  }, [_c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-grid"
  }, [_c('label', {
    staticClass: "p-col-12 p-mb-2 p-md-2 p-mb-md-0",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-10"
  }, [_c('span', [_vm._v("Permanent")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-grid"
  }, [_c('label', {
    staticClass: "p-col-12 p-mb-2 p-md-2 p-mb-md-0",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-10"
  }, [_c('span', [_vm._v("Working")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-grid"
  }, [_c('label', {
    staticClass: "p-col-12 p-mb-2 p-md-2 p-mb-md-0",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("EmpGroup")]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-10"
  }, [_c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-grid"
  }, [_c('label', {
    staticClass: "p-col-12 p-mb-2 p-md-2 p-mb-md-0",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Supervisor")]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-10"
  }, [_c('span', [_vm._v("Sushant shiwakoti"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "pi pi-mobile"
  }), _vm._v(" 9802345678\n            "), _c('span', {
    staticClass: "pi pi-envelope"
  }), _vm._v(" sushant.shiwakoti@digiconnect.com.np\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-6 p-lg-4"
  }, [_c('div', {
    staticClass: "box bgPersonal"
  }, [_c('h4', {
    staticClass: "titleColor"
  }, [_vm._v("Locations")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "p-fluid"
  }, [_c('div', {
    staticClass: "p-field p-grid"
  }, [_c('label', {
    staticClass: "p-col-12 p-mb-2 p-md-2 p-mb-md-0",
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-10"
  }, [_c('span', [_vm._v("Sushant Shiwakoti(0003)")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-grid"
  }, [_c('label', {
    staticClass: "p-col-12 p-mb-2 p-md-2 p-mb-md-0",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Department")]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-10"
  }, [_c('span', [_vm._v("9843263274")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-grid"
  }, [_c('label', {
    staticClass: "p-col-12 p-mb-2 p-md-2 p-mb-md-0",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-10"
  }, [_c('span', [_vm._v("sushntcc@gmail.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-grid"
  }, [_c('label', {
    staticClass: "p-col-12 p-mb-2 p-md-2 p-mb-md-0",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Division")]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-10"
  }, [_c('span', [_vm._v("0+")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-grid"
  }, [_c('label', {
    staticClass: "p-col-12 p-mb-2 p-md-2 p-mb-md-0",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("BusinessUnit")]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-10"
  }, [_c('span', [_vm._v("0+")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-grid"
  }, [_c('label', {
    staticClass: "p-col-12 p-mb-2 p-md-2 p-mb-md-0",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Supervisor2")]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-10"
  }, [_c('span', [_vm._v("0+")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-grid"
  }, [_c('label', {
    staticClass: "p-col-12 p-mb-2 p-md-2 p-mb-md-0",
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("ServicePerid")]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-10"
  }, [_c('span', [_vm._v(" 1years 30 days")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-md-6 p-lg-12"
  }, [_c('a', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": ""
    }
  }, [_vm._v("View Full Profile")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5aaca0d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/HumanResource/profile.vue
// module id = 2250
// module chunks = 0